var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found m-4 flex"},[_c('h1',{staticClass:"text-4xl mt-16 mx-auto"},[_vm._v("Vous vous êtes trompé de chemin ?")])])
}]

export { render, staticRenderFns }